<template>
    <div class="c-app">
        <TheSidebar />
        <CWrapper>
            <TheHeader />
            <Errors />
            <div class="c-body">
                <main class="c-main pt-2">
                    <CContainer fluid>
                        <transition name="fade" mode="out-in">
                            <router-view :key="$route.path" />
                        </transition>
                    </CContainer>
                </main>
            </div>
            <TheFooter />
        </CWrapper>
        <NewOrderNotification />
    </div>
</template>

<script>
    import TheSidebar from './TheSidebar'
    import TheHeader from './TheHeader'
    import TheFooter from './TheFooter'
    import Errors from '../components/Errors';
    import NewOrderNotification from '../components/NewOrderNotification';
    import orderNotificationService from '../services/orderNotificationService';
    import chatNotificationService from '../services/chatNotificationService';

    export default {
        name: 'TheContainer',
        components: {
            TheSidebar,
            TheHeader,
            TheFooter,
            Errors,
            NewOrderNotification
        },

        mounted() {
            this.initNotificationService();
        },

        beforeDestroy() {
            orderNotificationService.stop();
            chatNotificationService.stop();
        },

        methods: {
            initNotificationService() {
                orderNotificationService.requestNotificationPermission();
                chatNotificationService.requestNotificationPermission();

                orderNotificationService.start();
                chatNotificationService.start();
            }
        }
    }
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
